import { Typography } from "@mui/material";
import { CustomizedBox } from "components/Custom/CustomizedBox";
import DocumentDropzoneUI from "components/UI/DocumentDropzoneUI";
import { useDisable } from "hooks/use-disable";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const DailyWorksheet = () => {
  const { control, setValue } = useFormContext();
  const [disabled] = useDisable();
  const { t } = useTranslation();

  // 86d37db3t — no per-status disable in Edit mode. Uploader stays available
  // in every สถานะ; View Mode (`disabled`) is the only lock.
  return (
    <CustomizedBox margin={"1rem 0rem 0rem 0rem"}>
      <Typography fontWeight={600}>
        {t("logistic.delivery_trip.attachment_list")}
      </Typography>
      <DocumentDropzoneUI
        control={control}
        name="attachment_list"
        setValue={setValue}
        disabled={disabled}
        maxSize={5}
        multiple
      />
    </CustomizedBox>
  );
};

export default DailyWorksheet;
